import type { ContentItemWithId } from '../../types';

export type SectionWrapperProps = {
  items: ContentItemWithId[];
};

export const SectionWrapper = ({ items }: SectionWrapperProps) => (
  <div data-testid="section-wrapper">
    {items.map(item => (
      <div key={item.id} data-testid="section-wrapper-item">
        <div className="mb-4 font-bold text-2xl leading-xl">{item.title}</div>
        {item.content}
      </div>
    ))}
  </div>
);
